import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function directTripsOnlyClicked({
    searchParams = {},
    selected,
    totalTrips,
}) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    const property = {
        num_trips: totalTrips,
        selected,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_search',
        label: 'direct_trips',
        property,
    });

    amplitude.track('search_filtered', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        filter_type: 'transfers',
        results_count_before: totalTrips,
        updated_from: selected
            ? 'include_transfers'
            : 'no_transfers',
        updated_to: selected
            ? 'no_transfers'
            : 'include_transfers',
    });
}

function includeNearbyLocationsClicked({
    searchParams = {},
    selected,
    totalTrips,
}) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    const property = {
        num_trips: totalTrips,
        selected,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'directions',
        label: 'nearby_locations',
        property,
    });

    amplitude.track('search_filtered', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        filter_type: 'nearby_locations',
        results_count_before: totalTrips,
        updated_from: !selected,
        updated_to: selected,
    });
}

export default {
    directTripsOnlyClicked,
    includeNearbyLocationsClicked,
};
